import "./Home.module.css";
import TestataFelinova from "@/reusable_sections/Header";
import LixrExperienceBegins from "./sections/LixrExperienceBegins";
import FeaturedStatementPieces from "./sections/FeaturedStatementPieces";
import ExploreByCategory from "./sections/ExploreByCategory";
import TheMistoExperience from "./sections/TheMistoExperience";
import StudentBreakthroughs from "./sections/StudentBreakthroughs";
import RestezInforme from "./sections/RestezInforme";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <TestataFelinova />
      <LixrExperienceBegins />
      <FeaturedStatementPieces />
      <ExploreByCategory />
      <TheMistoExperience />
      <StudentBreakthroughs />
      <RestezInforme />
      <Footer />
    </div>;
}